import { FeatureFlag } from '../enums/FeatureFlag';
import { CacheEntry } from '../types/CacheEntry';

export const resolveFromCache = (entry: CacheEntry, flag: FeatureFlag): boolean =>
  Boolean(entry?.flags ? entry.flags[flag] : false);
